import { Injectable } from '@angular/core';
import {
  DataModel,
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { SystemService } from 'common/services/core-services/system.service';
import { GridWidgetService } from '../grid-widget.services';
import { ApplicantsDataService } from 'common/services/data-services/admin/applicants-dashboard/applicant-service.service';
import { API_URL, FORM_STEP_OPTIONS } from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { ApplicantsGridMetaModel } from 'common/models/page-models/applicants/applicant-table/applicant-grid-meta.model';
import {
  ApplicantsModel,
  ApplicantsListingModel,
  ApplicationGridParams,
} from 'common/models/page-models/applicants/applicant-table/applicant-grid.model';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { DepartmentListDataService } from 'common/services/data-services/custom-service/department-list-service';
import { zoneListDataService } from 'common/services/data-services/custom-service/zoneList-service';
import { resendDocDataService } from 'common/services/data-services/admin/applicants-dashboard/resendUploadDoc.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { ApplicantFilterCountDataService } from 'common/services/data-services/admin/applicants-dashboard/applicant-filter-count.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicantsWidgetService extends GridWidgetService<
  ApplicantsModel,
  ApplicantsListingModel
> {
  constructor(
    protected override ds: ApplicantsDataService,
    protected systemService: SystemService,
    protected stateList: stateListDataService,
    protected department: DepartmentListDataService,
    protected zoneList: zoneListDataService,
    private applicantCount: ApplicantFilterCountDataService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new ApplicantsGridMetaModel().getMetaModel();
    return meta;
  }

  // override prepareMetaModel(dataModel: DataModel, metaModel: SmMetaModel, routeData: WidgetModel): Promise<SmMetaModel> {
  //     re
  // }

  override prepareMetaModel(
    dataModel: DataModel,
    metaModel: SmMetaModel,
    routeData: WidgetModel
  ): Promise<SmMetaModel> {
    return new Promise<SmMetaModel>((resolve, reject) => {
      this.stateList.postData('').then((data) => {
        routeData.transferData.filterMeta.properties.selectedState.options =
          data.details;
        routeData.transferData.filterMeta.properties.stateId.options =
          data.details;
        metaModel.properties.filters.selectedState.values = data.details;
        metaModel.properties.stateFilerConstant = data.details;
        routeData.transferData.filterMeta.properties.collageStateId.options =
          data.details;
      });
      this.department.postData('').then((data) => {
        routeData.transferData.filterMeta.properties.department.options =
          data.details;
        metaModel.properties.filters.selectedBranch.values = data.details;
        routeData.transferData.filterMeta.properties.branchId.options =
          data.details;
      });
      this.zoneList.postData('').then((data) => {
        routeData.transferData.filterMeta.properties.selectedRegion.options =
          data.details;
        metaModel.properties.filters.selectedRegion.values = data.details;
      });
      this.applicantCount.postData('').then((data) => {
        // console.log(metaModel.properties.filters.boys.boysCount);
        metaModel.properties.filters.boys.boysCount = data.details.totalBoysCount
        metaModel.properties.filters.girls.girlsCount = data.details.totalGirlsCount
        metaModel.properties.filters.selectedBranch.branchCount = data.details.totalBranchApplicantCount
        metaModel.properties.filters.selectedState.stateCount = data.details.totalStateApplicantCount
        metaModel.properties.filters.selectedRegion.regionCount = data.details.totalRegionApplicantCount
        metaModel.properties.filters.other.otherCount = data.details.totalOthersCount
        metaModel.properties.filters.total.total = data.details.totalCount

      });
      resolve(metaModel);
    });
  }


  async generateDashboardData(params: any, apiUrl: any): Promise<any> {
    return await new Promise<any>((resolve, reject) => {
      const payload = new ApplicationGridParams();
      const selectedOption = FORM_STEP_OPTIONS.find(
        (option) =>
          option.name ===
          params.status
      );
      console.log(params.status, selectedOption)
      // payload.statusFlag=selectedOption === undefined ? 0 : Number(selectedOption.id);
      // payload.region_search=params.selectedRegion === '' ? '' : params.selectedRegion;
      // payload.state_search=params.selectedState === '' ? '' : params.selectedState;
      // payload.department_search=params.department === '' ? '' : params.department;
      // payload.gender_search=params.allGenders?.toLowerCase() === '' ? '' : params.allGenders?.toLowerCase()
      // console.log(payload);

      payload.statusFlag = selectedOption === undefined ? 0 : Number(selectedOption.id);

      payload.region_search = params.selectedRegion ? params.selectedRegion : '';
      payload.state_search = params.selectedState ? params.selectedState : '';
      payload.department_search = params.department ? params.department : '';
      payload.gender_search = params.allGenders
        ? params.allGenders.toLowerCase()
        : '';


      this.ds
        .postDataToCustomEndPoint(payload, null, environment.apiUrl + apiUrl)
        .then((result: any) => {
          this.ds
            .createGridModel(
              result,
              new GridParams(),
              this.ds.getDataParam(),
              this.ds.getExtraParam()
            )
            .then((gridData) => {
              resolve(gridData);
            })
            .catch((e) => {
              reject(e);
            });
          this.systemService.showSuccess(result.msg);
        });
    });
  }
}
